<script>
export default {
    data() {
        return {
            value: "",
            isFocussed: false,
        };
    },

    props: {
        type: {
            type: String,
            default: "text",
        },
        required: {
            type: Boolean,
            default: false,
        },
        defaultValue: String,
        name: String,
        label: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
    },

    computed: {
        hasValue: function () {
            return this.value.length > 0;
        },
        maxTextareaHeight: function () {
            return 1000;
        },
    },

    watch: {},

    methods: {
        onFocus: function () {
            this.isFocussed = true;
        },
        onBlur: function () {
            this.isFocussed = false;
        },
        didSelectClear: function (e) {
            e.preventDefault();
            this.$emit("input", null);
        },
    },

    components: {},

    created() {},

    destroyed() {},

    mounted() {
        this.value = this.defaultValue;
    },
};
</script>

<style></style>

<template>
    <div
        class="form-field"
        :class="{
            'form-field--has-value': hasValue,
            'form-field--focus': isFocussed,
        }"
    >
        <label :for="'input-' + name" class="form-field__label">{{
            label
        }}</label>

        <textarea-autosize
            v-if="type == 'textarea'"
            :id="'input-' + name"
            type="text"
            class="form-field__input form-field__input--textarea"
            :name="name"
            @focus="onFocus()"
            @blur="onBlur()"
            :placeholder="placeholder"
            v-model="value"
            v-on:change="$emit('input', $event.target.value)"
            :required="required"
        />

        <input
            v-else
            :id="'input-' + name"
            type="text"
            class="form-field__input"
            :name="name"
            @focus="onFocus()"
            @blur="onBlur()"
            :placeholder="placeholder"
            v-model="value"
            v-on:change="$emit('input', $event.target.value)"
            :required="required"
        />
    </div>
</template>
